export interface ServicePricing {
  type: string;
  basePrice: number;
  description: string;
  category: 'routine' | 'specialized' | 'emergency';
}

export const APPOINTMENT_PRICING: Record<string, ServicePricing> = {
  'Performance Evaluation': {
    type: 'Performance Evaluation',
    basePrice: 225.00,
    description: 'Comprehensive performance assessment including gait analysis, fitness evaluation, and recommendations',
    category: 'routine'
  },
  'PPE (Pre-Purchase Exam)': {
    type: 'PPE (Pre-Purchase Exam)',
    basePrice: 450.00,
    description: 'Pre-purchase examination including thorough physical assessment, lameness evaluation, and veterinary certificate',
    category: 'specialized'
  },
  'Vaccination': {
    type: 'Vaccination',
    basePrice: 85.00,
    description: 'Core vaccination administration including health assessment',
    category: 'routine'
  },
  'Dental Care': {
    type: 'Dental Care',
    basePrice: 325.00,
    description: 'Complete dental examination and floating, including sedation',
    category: 'specialized'
  },
  'Emergency': {
    type: 'Emergency',
    basePrice: 750.00,
    description: 'Emergency call service with immediate medical attention and stabilization',
    category: 'emergency'
  },
  'Surgery': {
    type: 'Surgery',
    basePrice: 2500.00,
    description: 'Surgical procedure including anesthesia, monitoring, and post-operative care',
    category: 'specialized'
  }
};
